import React from 'react';
import PropTypes from 'prop-types';

const PriceInformationDetails = ({ addressTitle, priceInformation }) => {
  const {
    APARTMENT_BUY: apartmentBuy,
    APARTMENT_RENT: apartmentRent,
    HOUSE_BUY: houseBuy,
    HOUSE_RENT: houseRent,
  } = priceInformation;
  const sellingPriceFormat = new Intl.NumberFormat('de-DE', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
  const rentPriceFormat = new Intl.NumberFormat('de-DE', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
  return (
    <>
      <div className="margin-bottom-s palm-margin-bottom-m">
        <h3 className="font-standard font-line-standard padding-none font-semibold margin-bottom-s palm-margin-bottom-m">
          Kaufpreise
        </h3>
        <ul className="list-bullet">
          <li className="margin-bottom-s palm-margin-bottom-m">
            <strong>Häuser:</strong> Der durchschnittliche Kaufpreis liegt in {addressTitle} bei{' '}
            <strong>{sellingPriceFormat.format(houseBuy.price)} €/m²</strong>. Für die teuerste Immobilie müssen
            Interessierte momentan <strong>{sellingPriceFormat.format(houseBuy.mostExpensive)} €/m²</strong> zahlen. Es
            geht aber auch günstiger: Der niedrigste Quadratmeterpreis liegt hier bei{' '}
            <strong>{sellingPriceFormat.format(houseBuy.leastExpensive)} €/m²</strong>.
          </li>
          <li className="margin-bottom-s palm-margin-bottom-m">
            <strong>Wohnungen:</strong> In {addressTitle} liegt der Quadratmeterpreis für eine Wohnung bei
            durchschnittlich <strong>{sellingPriceFormat.format(apartmentBuy.price)} €/m²</strong>. Während die
            teuersten Eigentumswohnungen in {addressTitle} einen Quadratmeterpreis von bis zu{' '}
            <strong>{sellingPriceFormat.format(apartmentBuy.mostExpensive)} €/m²</strong> erzielen, liegen die
            Kaufpreise für die günstigsten Wohnungen bei{' '}
            <strong>{sellingPriceFormat.format(apartmentBuy.leastExpensive)} €/m²</strong>.
          </li>
        </ul>
      </div>
      <div>
        <h3 className="font-standard font-line-standard padding-none font-semibold margin-bottom-s palm-margin-bottom-m">
          Mietpreise
        </h3>
        <ul className="list-bullet">
          <li className="margin-bottom-s palm-margin-bottom-m">
            <strong>Häuser:</strong> Der durchschnittliche Preis in {addressTitle} liegt bei{' '}
            <strong>{rentPriceFormat.format(houseRent.price)} €/m²</strong>. Die Preisspanne reicht vom niedrigsten
            Mietpreis von <strong>{rentPriceFormat.format(houseRent.leastExpensive)} €/m²</strong> bis zum höchsten
            Quadratmeterpreis von <strong>{rentPriceFormat.format(houseRent.mostExpensive)} €/m²</strong>.
          </li>
          <li className="margin-bottom-none">
            <strong>Wohnungen:</strong> Der durchschnittliche Mietpreis für Wohnungen liegt in {addressTitle} bei
            <strong> {rentPriceFormat.format(apartmentRent.price)} €/m²</strong>. Der niedrigste Preis für Mietwohnungen
            liegt bei <strong>{rentPriceFormat.format(apartmentRent.leastExpensive)} €/m²</strong>. Die obere
            Preisgrenze befindet sich bei <strong>{rentPriceFormat.format(apartmentRent.mostExpensive)} €/m²</strong>.
          </li>
        </ul>
      </div>
    </>
  );
};

PriceInformationDetails.propTypes = {
  addressTitle: PropTypes.string.isRequired,
  priceInformation: PropTypes.object.isRequired,
};

export default PriceInformationDetails;
